import DAppsIcon from './DAppsIcon'

export default DAppsIcon
